<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-layout>
    <v-dialog v-model="dialog" persistent max-width="500">
      <v-card>
        <v-card-title>
          {{item.type}} löschen
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" xs="12">
              <span class="font-weight-bold subheading my-5">
              Möchten Sie diesen Eintrag wirklich löschen?
              </span>
            </v-col>
            <v-col cols="12" xs="12">
            <span class="subheading my-5">
              &bdquo;{{item.name}}&ldquo;
            </span>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="dialog=false" small class="radiusBtn text-none">Nicht löschen</v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="deleteItem()" color="primary" small dark class="radiusBtn text-none">Löschen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
  export default {
    name: 'DialogDeleteItem',
    components: {},
    methods: {
      open: function (item) {
        this.dialog = true
        this.item = item
      },
      deleteItem: function () {
        this.dialog = false
        this.$emit('doDelete', this.item)
      }
    },
    data () {
      return {
        dialog: false,
        item: {}
      }
    },
    mounted () {
    }
  }
</script>

<style scoped>

</style>
